import api from '@/api';

const { $student, $canvas } = api;

export const { $students, $studentCanvas, $materias } = $student

export const { $canva, $users, $grades} = $canvas


